import React from 'react';
import PropTypes from 'prop-types';
import './PushPreviewSection.scss';

const PushPreviewSection = ({ pushHeadline, pushBody }) => {
  const hasContent = pushHeadline.trim() || pushBody.trim();

  return (
    <section className='push-preview announcements-section'>
      <h2 className='announcements-section-title'>Push Notification Preview</h2>
      <div className='push-preview-phone'>
        <div className='push-preview-notch' />
        <div className='push-preview-screen'>
          {hasContent ? (
            <div className='push-preview-notification'>
              <div className='push-preview-app-icon'>
                Shop
                <br />
                My
              </div>
              <div className='push-preview-notification-body'>
                {pushHeadline.trim() && <div className='push-preview-title'>{pushHeadline.trim()}</div>}
                {pushBody.trim() && <div className='push-preview-text'>{pushBody.trim()}</div>}
              </div>
            </div>
          ) : (
            <div className='push-preview-empty'>Fill in the push notification fields to see a preview.</div>
          )}
        </div>
      </div>
    </section>
  );
};

PushPreviewSection.propTypes = {
  pushHeadline: PropTypes.string.isRequired,
  pushBody: PropTypes.string.isRequired
};

export default PushPreviewSection;
